define(['angular'], function(angular) {


    /**
     * @class x3IntegrationStatusService
     */
    function X3IntegrationStatusService() {
        var self = this;

        self.X3_INTEGRATION_STATUS_READY = 'Prêt pour intégration X3';
        self.X3_INTEGRATION_STATUS_PENDING = 'En attente intégration X3';
        self.X3_INTEGRATION_STATUS_INTEGRATED = 'Intégré dans X3';

        /**
         * Get a property for the OFFERS object of this service
         * @param  {object} orderType
         * @param  {String} prop      OFFERS property wanted
         * @return {String} given property
         */
        self.getX3IntegrationStatus = function getX3IntegrationStatus(order) {
            if (self.isIntegratedIntoX3(order)) {
                return self.X3_INTEGRATION_STATUS_INTEGRATED;
            }
            if (order.isExportedForX3) {
                return self.X3_INTEGRATION_STATUS_PENDING;
            }
            if (order.isReadyForX3Integration) {
                return self.X3_INTEGRATION_STATUS_READY;
            }

            return '';
        };

        /**
         * @param  {object} order
         * @return {Boolean}
         */
        self.isIntegratedIntoX3 = function isIntegratedIntoX3(order) {
            return !!order.cmdeKey;
        };

        return self;
    }

    X3IntegrationStatusService.$inject = [];

    angular
        .module('app.bdc.common.x3IntegrationStatusService', [])
        .factory('x3IntegrationStatusService', X3IntegrationStatusService);
});
